import { MESSAGE_1 } from "./message1";

export const MAAP_MESSAGE = [
	MESSAGE_1
];
